<template>
  <div>
    <Breadcrumb msg1="收费管理" msg2="收费开单" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="5"><el-input v-model="query.charge_no" placeholder="收费单号" clearable></el-input></el-col>
        <el-col :span="4">
          <el-select v-model="query.charge_type" placeholder="类型" clearable>
            <el-option label="诊疗" value="诊疗"></el-option>
            <el-option label="商品" value="商品"></el-option>
            <el-option label="综合" value="综合"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="query.status" placeholder="状态" clearable>
            <el-option label="已收费" value="已收费"></el-option>
            <el-option label="部分退" value="部分退"></el-option>
            <el-option label="已退" value="已退"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="openBill">收费开单</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="单号" prop="chargeNo" width="150"></el-table-column>
        <el-table-column label="客户" width="100"><template slot-scope="scope">{{ customerName(scope.row.customerId) }}</template></el-table-column>
        <el-table-column label="类型" prop="chargeType" width="80"></el-table-column>
        <el-table-column label="应收" prop="totalAmount" width="90"></el-table-column>
        <el-table-column label="优惠" prop="discount" width="80"></el-table-column>
        <el-table-column label="实收" prop="paidAmount" width="90"></el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '已退' ? 'danger' : 'success'">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="时间" prop="chargeTime" width="160"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="view(scope.row.id)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog title="收费开单" :visible.sync="billShow" width="900px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px" v-if="billShow">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户" required>
              <el-select v-model="form.customer_id" filterable remote placeholder="输入姓名/手机号搜索" :remote-method="searchCustomer" style="width: 100%" @change="onCustomerChange">
                <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收费类型">
              <el-select v-model="form.charge_type" style="width: 100%">
                <el-option label="诊疗" value="诊疗"></el-option>
                <el-option label="商品" value="商品"></el-option>
                <el-option label="综合" value="综合"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="价格体系">
              <el-select v-model="form.price_system_id" clearable style="width: 100%">
                <el-option v-for="p in priceSystems" :key="p.id" :label="p.name" :value="p.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会员余额">
              <el-alert v-if="memberInfo" :title="'¥ ' + memberInfo.balance + '（可用储值）'" type="success" :closable="false"></el-alert>
              <span v-else style="color: #909399">非会员 / 无余额</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-divider content-position="left">费用明细</el-divider>
      <el-table :data="form.items" border size="small">
        <el-table-column label="类型" width="110">
          <template slot-scope="scope">
            <el-select v-model="scope.row.itemType" size="mini">
              <el-option label="商品" value="商品"></el-option>
              <el-option label="项目" value="项目"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="选择" width="220">
          <template slot-scope="scope">
            <el-select v-model="scope.row.itemId" size="mini" filterable placeholder="选择商品/项目" style="width: 100%" @change="pickItem(scope.row)">
              <el-option v-for="p in products" :key="p.id" :label="p.name" :value="p.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="名称">
          <template slot-scope="scope"><el-input v-model="scope.row.itemName" size="mini"></el-input></template>
        </el-table-column>
        <el-table-column label="数量" width="90">
          <template slot-scope="scope"><el-input v-model.number="scope.row.quantity" size="mini" @change="calc(scope.row)"></el-input></template>
        </el-table-column>
        <el-table-column label="单价" width="100">
          <template slot-scope="scope"><el-input v-model.number="scope.row.price" size="mini" @change="calc(scope.row)"></el-input></template>
        </el-table-column>
        <el-table-column label="金额" width="90">
          <template slot-scope="scope">{{ scope.row.amount }}</template>
        </el-table-column>
        <el-table-column label="操作" width="70">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="form.items.splice(scope.$index, 1)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button size="mini" icon="el-icon-plus" style="margin-top: 8px" @click="form.items.push({ itemType: '商品', itemId: null, itemName: '', quantity: 1, price: 0, amount: 0 })">添加明细</el-button>

      <el-row style="margin-top: 15px">
        <el-col :span="8"><el-form-item label="优惠金额" label-width="90"><el-input v-model.number="form.discount" type="number" @input="recalc"></el-input></el-form-item></el-col>
        <el-col :span="8"><el-form-item label="应收金额" label-width="90"><el-input :value="payable.toFixed(2)" disabled></el-input></el-form-item></el-col>
        <el-col :span="8"><el-form-item label="支付合计" label-width="90"><el-input :value="paidTotal.toFixed(2)" disabled></el-form-item></el-col>
      </el-row>

      <el-divider content-position="left">组合支付</el-divider>
      <el-table :data="form.payments" border size="small">
        <el-table-column label="支付方式" width="160">
          <template slot-scope="scope">
            <el-select v-model="scope.row.payMethod" size="mini">
              <el-option label="现金" value="现金"></el-option>
              <el-option label="微信" value="微信"></el-option>
              <el-option label="支付宝" value="支付宝"></el-option>
              <el-option label="银行卡" value="银行卡"></el-option>
              <el-option label="储值" value="储值"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="金额" width="160">
          <template slot-scope="scope"><el-input v-model.number="scope.row.amount" size="mini" @change="recalc"></el-input></template>
        </el-table-column>
        <el-table-column label="交易号">
          <template slot-scope="scope"><el-input v-model="scope.row.tradeNo" size="mini" :disabled="scope.row.payMethod === '现金' || scope.row.payMethod === '储值'"></el-input></template>
        </el-table-column>
        <el-table-column label="操作" width="70">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="form.payments.splice(scope.$index, 1)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button size="mini" icon="el-icon-plus" style="margin-top: 8px" @click="form.payments.push({ payMethod: '现金', amount: 0, tradeNo: '' })">添加支付方式</el-button>

      <span slot="footer">
        <el-button @click="billShow = false">取消</el-button>
        <el-button type="primary" @click="submit">提交收费</el-button>
      </span>
    </el-dialog>

    <el-dialog title="收费单详情" :visible.sync="detailShow" width="700px">
      <template v-if="detail.charge">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="单号">{{ detail.charge.chargeNo }}</el-descriptions-item>
          <el-descriptions-item label="客户">{{ customerName(detail.charge.customerId) }}</el-descriptions-item>
          <el-descriptions-item label="应收">{{ detail.charge.totalAmount }}</el-descriptions-item>
          <el-descriptions-item label="实收">{{ detail.charge.paidAmount }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ detail.charge.status }}</el-descriptions-item>
          <el-descriptions-item label="时间">{{ detail.charge.chargeTime }}</el-descriptions-item>
        </el-descriptions>
        <el-divider content-position="left">明细</el-divider>
        <el-table :data="detail.items" border size="small">
          <el-table-column prop="itemName" label="项目"></el-table-column>
          <el-table-column prop="quantity" label="数量" width="80"></el-table-column>
          <el-table-column prop="price" label="单价" width="100"></el-table-column>
          <el-table-column prop="amount" label="金额" width="100"></el-table-column>
        </el-table>
        <el-divider content-position="left">支付记录</el-divider>
        <el-table :data="detail.payments" border size="small">
          <el-table-column prop="payMethod" label="方式"></el-table-column>
          <el-table-column prop="amount" label="金额" width="120"></el-table-column>
          <el-table-column prop="tradeNo" label="交易号"></el-table-column>
        </el-table>
      </template>
      <span slot="footer"><el-button @click="detailShow = false">关闭</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import { loadCustomerMap, customerName } from '@/utils/customerName'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, charge_no: '', charge_type: '', status: '' },
      list: [],
      total: 0,
      billShow: false,
      form: { items: [], payments: [], discount: 0 },
      customerOptions: [],
      products: [],
      priceSystems: [],
      memberInfo: null,
      detailShow: false,
      detail: { charge: null, items: [], payments: [] }
    }
  },
  computed: {
    payable () {
      const sum = this.form.items.reduce((s, i) => s + (Number(i.amount) || 0), 0)
      return Math.max(0, sum - (Number(this.form.discount) || 0))
    },
    paidTotal () {
      return this.form.payments.reduce((s, p) => s + (Number(p.amount) || 0), 0)
    }
  },
  created () {
    this.getData()
    loadCustomerMap(this.$axios.http)
    this.$axios.http.get('/products', { params: { page: 1, limit: 500, status: 1 } }).then(r => {
      if (r.data.status === 200) this.products = r.data.data.records || []
    })
    this.$axios.http.get('/priceSystems').then(r => {
      if (r.data.status === 200) this.priceSystems = r.data.data || []
    })
  },
  methods: {
    customerName,
    getData () {
      this.$axios.get('/charges', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    searchCustomer (kw) {
      if (!kw) return
      this.$axios.http.get('/customers/select', { params: { keyword: kw } }).then(r => {
        if (r.data.status === 200) this.customerOptions = r.data.data || []
      })
    },
    onCustomerChange (cid) {
      this.memberInfo = null
      const c = this.customerOptions.find(x => x.id === cid)
      if (c && c.phone) {
        this.$axios.http.get('/members', { params: { page: 1, limit: 5, keyword: c.phone } }).then(r => {
          if (r.data.status === 200 && r.data.data.records && r.data.data.records.length > 0) {
            this.memberInfo = r.data.data.records[0].member || r.data.data.records[0]
          }
        })
      }
    },
    pickItem (row) {
      const p = this.products.find(x => x.id === row.itemId)
      if (p) {
        row.itemName = p.name
        row.price = p.retailPrice || 0
        this.calc(row)
      }
    },
    calc (row) {
      row.amount = ((row.quantity || 0) * (row.price || 0)).toFixed(2)
      this.recalc()
    },
    recalc () {},
    openBill () {
      this.form = { customer_id: null, charge_type: '综合', price_system_id: null, discount: 0, items: [], payments: [] }
      this.memberInfo = null
      this.billShow = true
    },
    submit () {
      if (!this.form.customer_id) { this.$message.warning('请选择客户'); return }
      if (this.form.items.length === 0) { this.$message.warning('请至少添加一条费用明细'); return }
      if (this.form.payments.length === 0) { this.$message.warning('请至少添加一种支付方式'); return }
      // 前端校验：支付合计 = 应收
      if (Math.abs(this.paidTotal - this.payable) > 0.01) {
        this.$message.error('支付合计（¥' + this.paidTotal.toFixed(2) + '）必须等于应收金额（¥' + this.payable.toFixed(2) + '）')
        return
      }
      // 储值支付校验余额
      const stored = this.form.payments.filter(p => p.payMethod === '储值').reduce((s, p) => s + Number(p.amount || 0), 0)
      if (stored > 0) {
        if (!this.memberInfo) { this.$message.error('该客户不是会员，无法使用储值支付'); return }
        if (Number(this.memberInfo.balance || 0) < stored) {
          this.$message.error('储值余额不足：可用 ¥' + this.memberInfo.balance + '，需支付 ¥' + stored)
          return
        }
      }
      this.$axios.post('/charges', () => { this.billShow = false; this.getData() }, this.form)
    },
    view (id) {
      this.$axios.http.get(`/charges/${id}`).then(r => {
        if (r.data.status === 200) {
          this.detail = { charge: r.data.data.charge, items: r.data.data.items || [], payments: r.data.data.payments || [] }
          this.detailShow = true
        }
      })
    }
  }
}
</script>
